import { ApplicationTrophyDto } from '~/modules/Products/Application/Dtos/ApplicationTrophyDto'
import { ComponentTrophyDto } from '~/modules/Products/Infrastructure/Dtos/ComponentTrophyDto'
import { ComponentProductAnimation } from '~/modules/Products/Infrastructure/Dtos/ComponentProductAnimation'

export class ComponentTrophyDtoTransformer {
  public static fromApplication (applicationTrophyDto: ApplicationTrophyDto): ComponentTrophyDto {
    let animation: ComponentProductAnimation | null = null

    if (applicationTrophyDto.animation !== null) {
      animation = {
        url: applicationTrophyDto.animation.url,
        type: applicationTrophyDto.animation.type,
      }
    }

    return {
      id: applicationTrophyDto.id,
      type: applicationTrophyDto.type,
      content: {
        header: applicationTrophyDto.content.header,
        title: applicationTrophyDto.content.title,
        subtitle: applicationTrophyDto.content.subtitle,
      },
      description: applicationTrophyDto.description,
      discipline: applicationTrophyDto.discipline,
      animation: animation,
      mintStatus: applicationTrophyDto.mintStatus,
      imageUrl: applicationTrophyDto.imageUrl,
    }
  }
}
